// @ts-nocheck
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Tabs, Tab } from '@material-ui/core';
import { EmptyState, Panel, TabPanel } from '../../../common/components';
import ActivityService from '../services/ActivityService';
import ShowsTab from './partials/shows/ShowsTab';
import RecommendationsTab from './partials/recommendations/RecommendationsTab';

const TabIndex = {
  Shows: 0,
  Recommendations: 1,
};

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    minHeight: '500px',
  },
  content: {
    flex: '1',
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
}));

function ActivitiesPage() {
  const { userId } = useParams();
  const [tabIndex, setTabIndex] = useState(TabIndex.Shows);
  const [t] = useTranslation();
  const { data: activities } = useQuery(['activities', userId], async () => {
    const { data } = await ActivityService.fetchActivities(userId);
    return data;
  });

  const classes = useStyles();

  return (
    <Box id="Activities-container" className={classes.container}>
      <Panel id="Activities-panel" variant="contained">
        {!activities ? (
          <EmptyState variant="unavailable" message={t('activity.activitiesNotAvailable')} />
        ) : (
          <>
            <Tabs
              id="Activities-tabs"
              className={classes.tabs}
              data-value={tabIndex}
              value={tabIndex}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_event, index) => setTabIndex(index)}
            >
              <Tab
                id="Activities-showsTab"
                label={t('activity.shows')}
                data-index={TabIndex.Shows}
              />
              <Tab
                id="Activities-recommendationsTab"
                label={t('activity.recommendations')}
                data-index={TabIndex.Recommendations}
              />
            </Tabs>
            <Box id="Activities-tabsContent" className={classes.content}>
              <TabPanel index={TabIndex.Shows} currentIndex={tabIndex}>
                <ShowsTab activities={activities.activities} playbacks={activities.playbacks} />
              </TabPanel>
              <TabPanel index={TabIndex.Recommendations} currentIndex={tabIndex}>
                <RecommendationsTab
                  recommendationsMostWatched={activities.recommendationsMostWatched}
                  recommendationsUnwatchedProgram={activities.recommendationsUnwatchedProgram}
                  recommendationsNewEpisodes={activities.recommendationsNewEpisodes}
                />
              </TabPanel>
            </Box>
          </>
        )}
      </Panel>
    </Box>
  );
}

export default ActivitiesPage;
